<template>
  <div class="">
    <el-carousel trigger="click" class="banner" height="724px" :interval="10000" arrow="never">
      <el-carousel-item v-for="item in 4" :key="item">
        <el-image src="/images/banner.png" class="h-100 w-100" fit="cover"></el-image>
      </el-carousel-item>
    </el-carousel>
    <div class="section-new bg-eeeff3">
      <div class="menu">
        <div class="container bg-ff radius-4 p-30 flex align-center">
          <div class="flex-1 ptb-28 plr-30 bg-eeeff3 radius-4 cursor" :class="hoverIndex === 0 ? 'isHover' : ''" @mouseenter="toEnter(0)" @mouseleave="toLeave" @click="toPage('overallScheme')">
            <div class="font-20 color-292a2e font-bold font-yahei mb-12">整装方案</div>
            <div class="font-12 color-94 mb-2">行业顶级设计师量身打造</div>
            <div class="font-12 color-94">12大风格，100+方案</div>
            <div class="flex align-end justify-space-between">
              <div class="btn-30 radius-round bg-ff w-55">
                <img :src="hoverIndex === 0 ? '/images/jinruxz.png' : '/images/jinru.png'" alt="">
              </div>
              <img src="/images/icon-zhengzhuangfangan.png" alt="">
            </div>
          </div>
          <div class="flex-1 p-30 bg-eeeff3 radius-4 ml-10 cursor" :class="hoverIndex === 1 ? 'isHover' : ''" @mouseenter="toEnter(1)" @mouseleave="toLeave" @click="toPage('goods')">
            <div class="font-20 color-292a2e font-bold font-yahei mb-12">选单品</div>
            <div class="font-12 color-94 mb-2">100+工厂，10000+产品</div>
            <div class="font-12 color-94">全品类随意挑</div>
            <div class="flex align-end justify-space-between">
              <div class="btn-30 radius-round bg-ff w-55">
                <img :src="hoverIndex === 1 ? '/images/jinruxz.png' : '/images/jinru.png'" alt="">
              </div>
              <img src="/images/icon-xuandanpin.png" alt="">
            </div>
          </div>
          <img src="/images/icon-diy.png" alt="" class="mlr-30 diy-button">
          <div class="flex-1 p-30 bg-eeeff3 radius-4 mr-10 cursor" :class="hoverIndex === 2 ? 'isHover' : ''" @mouseenter="toEnter(2)" @mouseleave="toLeave" @click="toPage('brand')">
            <div class="font-20 color-292a2e font-bold font-yahei mb-12">找品牌</div>
            <div class="font-12 color-94 mb-2">时尚/轻奢/复古/简约</div>
            <div class="font-12 color-94">全一线品牌</div>
            <div class="flex align-end justify-space-between">
              <div class="btn-30 radius-round bg-ff w-55">
                <img :src="hoverIndex === 2 ? '/images/jinruxz.png' : '/images/jinru.png'" alt="">
              </div>
              <img src="/images/icon-xuanpinpai.png" alt="">
            </div>
          </div>
          <div class="flex-1 p-30 bg-eeeff3 radius-4 cursor" :class="hoverIndex === 3 ? 'isHover' : ''" @mouseenter="toEnter(3)" @mouseleave="toLeave"  @click="toPage('case')">
            <div class="font-20 color-292a2e font-bold font-yahei mb-12">看案例</div>
            <div class="font-12 color-94 mb-2">我们只做有温度的设计</div>
            <div class="font-12 color-94">呈现真实实景</div>
            <div class="flex align-end justify-space-between">
              <div class="btn-30 radius-round bg-ff w-55">
                <img :src="hoverIndex === 3 ? '/images/jinruxz.png' : '/images/jinru.png'" alt="">
              </div>
              <img src="/images/icon-kananli.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="main container" v-if="goodsList.length>0">
        <img src="/images/zuixindanpin.png" alt="" class="mb-45">
        <div class="flex align-start">
          <div class="left flex-column justify-space-between align-start cursor" :class="hoverIndex === 4 ? 'isHover' : ''" @mouseenter="toEnter(4)" @mouseleave="toLeave">
            <div>
              <img :src="hoverIndex === 4 ? '/images/icon-zuixindanpinxz.png' : '/images/icon-zuixindanpin.png'" alt="" class="mb-18">
              <div class="font-40 color-ff font-yahei mb-16">最新单品</div>
              <div class="color-94 font-16 font-yahei mb-2">设计源于生活</div>
              <div class="color-94 font-16 font-yahei">细节成就品质</div>
            </div>
            <div class="btn-40 bg-ff radius-round flex align-center justify-center w-147" @click="toPage('goods')">
              <span class="font-16 color-292a2e font-yahei mr-10">查看更多</span>
              <img :src="hoverIndex === 4 ? '/images/jinruxz.png' : '/images/jinruhei.png'" alt="">
            </div>
          </div>
          <div class="right flex-1 flex flex-wrap" >
            <goods-item v-for="(item, index) in goodsList.slice(0, 6)" :key="index" :goodsItem="item.goods" type = "1" :index="index"></goods-item>
          </div>
        </div>
      </div>
    </div>
    <div class="section-hot" v-if="hotGoodsList.length>0">
      <div class="container flex-column justify-center align-center">
        <div class="font-40 color-292a2e font-yahei text-center mb-4">热销单品</div>
        <div class="font-16 color-94 font-yahei text-center mb-48">爆款单品抢先购，总有一款属于你</div>
        <div class="flex align-center mb-30 ml--20">
          <goods-item v-for="(item, index) in hotGoodsList.slice(0, 5)" :goodsItem="item.goods" type="2" :key="index" :index="index"></goods-item>
        </div>
        <div class="btn-40 bg-292a2e radius-round flex align-center justify-center w-147" @click="toPage('goods')">
          <span class="font-16 color-ff font-yahei mr-10">查看更多</span>
          <img src="/images/jinrubai.png" alt="">
        </div>
      </div>
    </div>
    <div class="section-hot-case" v-if="programmeList.length>0">
      <div class="container flex-column justify-center align-center">
        <div class="font-40 color-292a2e font-yahei text-center mb-4">当季热销方案</div>
        <div class="font-16 color-94 font-yahei text-center mb-48">当季全国189+省会2W+用户认可推荐</div>
        <div class="flex flex-wrap mb-30">
          <div class="case-item mb-20 cursor" :class="index%3 === 0 ? '' : 'ml-19'" v-for="(item, index) in programmeList.slice(0, 4)" :key="index" :style="{background:'url(' + Utils.IMG_PREV+item.programme.programmePicList[0].pic + ') no-repeat center/cover'}">
            <div class="main flex-column align-center justify-center">
              <div class="flex-1  flex-column align-center justify-center">
                <div class="font-16 color-ff font-arial mb-6">{{item.programme.name}}</div>
                <div class="flex align-center mb-16">
                  <div class="tag-16-c19357" v-for="(tag, index) in item.programme.programmeTagList" :key="index">{{tag.name}}</div>
                </div>
                <div class="font-18 color-ff font-arial">¥{{Utils.toFixedNum(item.programme.lowPrice)}}~{{Utils.toFixedNum(item.programme.hightPrice)}}</div>
              </div>
              <div class="flex align-center justify-space-between w-100">
                <div class="flex align-center">
                  <span class="color-ff-5 font-12">推荐指数|</span>
                  <el-rate v-model="value" disabled :colors="['#fff', '#fff', '#fff']" disabled-void-color="rgba(255,255,255,0.4)"></el-rate>
                </div>
                <div class="color-ff-5 font-12">{{item.programme.style}}</div>
              </div>
            </div>
            <div class="mask flex align-center justify-center" @click="toDetail(item.programme.id)">
              <div class="btn-40 border-ff radius-round font-16 font-yahei w-124">打开方案</div>
            </div>
          </div>
        </div>
        <div class="btn-40 bg-292a2e radius-round flex align-center justify-center w-147" @click="toPage('overallScheme')">
          <span class="font-16 color-ff font-yahei mr-10">查看更多</span>
          <img src="/images/jinrubai.png" alt="">
        </div>
      </div>
    </div>
    <div class="section-case" v-if="officialProgrammeList.length>0">
      <div class="container flex-column justify-center align-center">
        <div class="font-40 color-ff font-yahei text-center mb-4">官方主推方案</div>
        <div class="font-16 color-94 font-yahei text-center mb-48">AI大数据从热度、品质、交付精选</div>
        <div class="flex align-center justify-center mb-30 w-100">
          <scheme-item v-for="(item, index) in officialProgrammeList.slice(0, 4)" :planItem="item.programme" :key="index" :isJian="true" :index="index"></scheme-item>
        </div>
        <div class="btn-40 bg-ff radius-round flex align-center justify-center w-147" :class="hoverIndex === 5 ? 'isHover' : ''" @mouseenter="toEnter(5)" @mouseleave="toLeave" @click="toPage('overallScheme')">
          <span class="font-16 color-292a2e font-yahei mr-10">查看更多</span>
          <img :src="hoverIndex === 5 ? '/images/jinrubai.png' : '/images/jinruhei.png'" alt="">
        </div>
      </div>
    </div>
    <div class="section-brand" v-if="brandList.length>0">
      <div class="container flex-column justify-center align-center">
        <div class="font-40 color-292a2e font-yahei text-center mb-4">品牌软装</div>
        <div class="font-16 color-94 font-yahei text-center mb-48">时尚/雅奢/极简/浪漫等软装品牌</div>
        <div class="mb-30 flex align-center flex-wrap">
            <div v-for="(item, index) in brandList" :key="index" class="brand-item" :class="index%4 === 0 ? '' : 'ml-20'" :style="{background:'url(' + Utils.IMG_PREV+item.brand.banner + ') no-repeat center/cover'}" @click="toBrandDetail(item.brand.id)">
            <div class="main flex align-center justify-center">
              <el-image :src="Utils.IMG_PREV+item.brand.photo" fit="cover" style="width:140px;"></el-image>
            </div>
            <div class="mask flex align-center justify-center">
              <div class="btn-40 border-ff radius-round font-16 font-yahei w-124">进入品牌</div>
            </div>
        </div>
        </div>
        <div class="btn-40 bg-292a2e radius-round flex align-center justify-center w-147" @click="toPage('brand')">
          <span class="font-16 color-ff font-yahei mr-10">查看更多</span>
          <img src="/images/jinrubai.png" alt="">
        </div> 
      </div>
    </div>
    <div class="section-classic" v-if="caseList.length>0">
      <div class="container flex-column justify-center align-center">
        <div class="font-40 color-292a2e font-yahei text-center mb-4">经典案例</div>
        <div class="font-16 color-94 font-yahei text-center mb-48">我们只做有温度的设计</div>
        <div class="main flex align-start cursor" v-if="caseList[0].cases.casePicList">
          <el-image :src="Utils.IMG_PREV + caseList[0].cases.casePicList[currentImgIndex].pic" fit="cover" class="pic mr-30"></el-image>
          <div class="flex-1">
            <div class="flex align-center justify-space-between mb-28">
              <div class="flex-1">
                <img src="/images/yinhao.png" alt="" class="mb-20">
                <div class="font-30 font-yahei color-292a2e mb-14">{{caseList[0].cases.name}}</div>
                <div class="flex align-center">
                  <div>
                    <div class="font-12 color-94 mb-6">设计风格</div>
                    <div class="font-16 font-yahei color-292a2e">{{caseList[0].cases.style}}</div>
                  </div>
                  <div class="line"></div>
                  <div>
                    <div class="font-12 color-94 mb-6">房屋户型</div>
                    <div class="font-16 font-yahei color-292a2e">{{caseList[0].cases.layout}}</div>
                  </div>
                  <div class="line"></div>
                  <div>
                    <div class="font-12 color-94 mb-6">装修面积</div>
                    <div class="font-16 font-yahei color-292a2e">{{caseList[0].cases.area}}㎡</div>
                  </div>
                </div>
              </div>
              <div class="line-dashed"></div>
              <div class="right">
                <div class="headImg mb-18" v-if="caseList[0].cases.designerHead"><el-image :src="Utils.IMG_PREV+caseList[0].cases.designerHead" fit="cover" class="w-100 h-100"></el-image></div>
                <div class="font-12 color-94 mb-6 text-center">设计师</div>
                <div class="font-16 color-292a2e font-yahei text-center">{{caseList[0].cases.designer == '全部设计师' ? '-':caseList[0].cases.designer}}</div>
              </div>
            </div>
            <div class="mb-28">
              <img src="/images/baohankongjian.png" alt="" class="block">
              <div class="room flex align-center" style="padding-left:40px" v-if="caseList[0].cases.caseSpaceList">
                <div class="flex align-center" v-for="(cellItem, cellIndex) in caseList[0].cases.caseSpaceList" :key="cellIndex">
                  <div class="flex-column align-center justify-center">
                    <div class="text-center">
                    <el-image
                    v-if="cellItem.icon"
                    style="width: 25px;"
                    class="mr-10"
                    :src="Utils.formatImg(cellItem.icon)"
                    fit="cover"></el-image>
                    </div>
                    <div class="font-14 font-yahei color-292a2e">{{cellItem.name}} </div>
                  </div>
                  <div class="line"></div>
                </div>
              </div>
            </div>
            <div class="font-16 color-2c333b font-yahei mb-6">设计说明</div>
            <div class="font-12 color-94 text-overflow-2 text mb-16">{{caseList[0].cases.profile}}</div>
            <div class="flex justify-end"><div class="btn-25 border-292a2e w-77 radius-round font-12" @click="toCaseDetail(caseList[0].cases.id)">查看详情</div></div>
          </div>
        </div>
        <div class="mb-50 flex align-center w-100">
          <div class="list-btn" @click="toPrev"><i class="el-icon-arrow-left"></i></div>
          <div class="list mlr-10 flex-1 w-0" ref="picList">
            <div class="flex align-center picList" :style="{transform: 'translateX('+ (-moveWidth) +'px)'}">
              <div class="case-item" :style="{background:'url(' + Utils.IMG_PREV+item.pic + ') no-repeat center/cover'}" :class="index === 0 ? '' : 'ml-10'" v-for="(item, index) in caseList[0].cases.casePicList" :key="index" @mouseenter="enter(index)">
              </div>
            </div>
          </div>
          <div class="list-btn" @click="toNext"><i class="el-icon-arrow-right"></i></div>
        </div>
        <div class="btn-40 bg-292a2e radius-round flex align-center justify-center w-147" @click="toPage('case')">
          <span class="font-16 color-ff font-yahei mr-10">查看更多</span>
          <img src="/images/jinrubai.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>  

<script>
import SchemeItem from '@/components/SchemeItem'
import GoodsItem from '@/components/GoodsIndex'
export default {
  name: "Index",
  components: {SchemeItem, GoodsItem},
  data () {
    return {
      hoverIndex: null,
      value: 5,
      list: [],
      imgIndex: 0,
      isSwitch: false,
      picIndex: 0,
      moveWidth: 0,
      scrollWidth: 0,
      goodsList: [],
      hotGoodsList: [],
      programmeList: [],
      officialProgrammeList: [],
      brandList: [],
      caseList: {},
      currentImgIndex: 0
    }
  },
  created () {
  },
  mounted () {
    this.getIndexDefine()
    // this.getGoods()
    // this.getHotGoods()
    // this.getHotProgramme()
    // this.getOfficialProgramme()
    // this.getBrand()
    // this.getCase()
  },
  methods: {
    getIndexDefine () {
        this.axios.post(`indexDefine/showIndex`, {}).then(res => {
        if (res.data.success) {
          for (let i=0;i<res.data.data.length;i++) {
            switch (res.data.data[i].name) {
              case '最新单品':
                this.goodsList = res.data.data[i].indexItemViewList
                break
              case '热销单品':
                this.hotGoodsList = res.data.data[i].indexItemViewList
                break
              case '当季热销方案':
                this.programmeList = res.data.data[i].indexItemViewList
                break
              case '官方主推方案':
                this.officialProgrammeList = res.data.data[i].indexItemViewList
                break
              case '品牌软装':
                this.brandList = res.data.data[i].indexItemViewList
                break
              case '经典案例':
                this.caseList= res.data.data[i].indexItemViewList
                break
            }
          }
          console.log(this.caseList)
        }
      })
    },
    getGoods () {
      let params = {
        limit: 6,
        page: 1
      }
      this.axios.post(`goods/queryForPage`, params).then(res => {
        if (res.data.success) {
          this.goodsList = res.data.data.list
        }
      })
    },
     getHotGoods () {
      let params = {
        limit: 4,
        page: 1
      }
      this.axios.post(`goods/queryForPage`, params).then(res => {
        if (res.data.success) {
          this.hotGoodsList = res.data.data.list
        }
      })
    },
    getHotProgramme () {
       this.axios.post(`programme/queryForPage`, {
        limit: 6,
        page: 1
      }).then(res => {
        if (res.data.success) {
          let list = res.data.data.list
          this.programmeList = list
        }
      })
    },
    getOfficialProgramme () {
       this.axios.post(`programme/queryForPage`, {
        limit: 3,
        page: 1
      }).then(res => {
        if (res.data.success) {
          let list = res.data.data.list
          this.officialProgrammeList = list
        }
      })
    },
    getBrand () {
      let params = {
        page: 1,
        limit: 8
      }
      this.axios.post('brand/queryForPage', params).then(res => {
        if (res.data.success) {
          this.brandList = res.data.data.list
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    getCase () {
      let params = {
        page: 1,
        limit: 1
      }
      this.axios.post('cases/queryForPage', params).then(res => {
        if (res.data.success) {
          if (res.data.data.list.length > 0) {
            this.caseList[0].cases = res.data.data.list[0]
            this.scrollWidth = (this.caseList[0].cases.casePicList.length - 1) * 134 + 124
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
     toDetail (id) {
      this.$router.push({path: '/schemeDetail',query:{id: id + '.html'}})
    },
    toBrandDetail (id) {
      this.$router.push({path: '/brandDetail',query: {id: id + '.html'}})
    },
     toCaseDetail (id) {
      this.$router.push({path: '/caseDetail',query: {id: id + '.html'}})
    },
    enter (index) {
      this.currentImgIndex = index
    },
    toNext () {
      if (this.scrollWidth < 1320) {
        return
      } else {
        if (this.moveWidth + 600 < this.scrollWidth - 1320) {
          this.moveWidth += 600
        } else {
          this.moveWidth = this.scrollWidth - 1320
        }
      }
    },
    toPrev () {
      if (this.moveWidth - 600 > 0) {
        this.moveWidth -= 600
      } else {
        this.moveWidth = 0
      }
    },
    onImg (e) {
      this.imgIndex = e
    },
    toEnter (index) {
      this.hoverIndex = index
    },
    toLeave () {
      this.hoverIndex = null
    },
    toPage (name) {
      console.log(name)
      this.$router.push({path: '/'+name+'.html'})
    }
  },
  watch: {
    imgIndex (e) {
      this.isSwitch = true
      setTimeout(() => {
        this.isSwitch = false
      }, 300)
    }
  }
};
</script>

<style lang="scss" scoped>
  .banner img{
    width: 100%;
    display: block;
  }
  .isHover{
    .color-94{
      color: #65513c;
    }
    .color-ff{
      color: #292a2e;
    }
    .color-292a2e{
      color: #fff;
    }
    .bg-ff{
      background: #292a2e;
    }
  }
  .section-new{
    width: 100%;
    position: relative;
    min-height: 244px;
    .diy-button{
      box-shadow: 0px 10px 30px 0px	rgba(41, 42, 46, 0.4);
      border-radius: 12px;
      cursor: pointer;
    }
    .menu{
      position: absolute;
      top: - 122px;
      left: 0;
      width: 100%;
      z-index: 9;
      .container{
        box-shadow: 0px 30px 70px 0px	rgba(41, 42, 46, 0.07);
      }
      .isHover{
        background: #c19357;
        .color-292a2e{
          color: #292a2e;
        }
      }
    }
    .main{
      padding-top: 167px;
      padding-bottom: 70px;
      .left{
        width: 335px;
        height: 658px;
        background: url('/images/zuixindanpinbg.png');
        padding: 60px 60px 90px;
        &.isHover{
          background: url('/images/zuixindanpinbgxz.png');
        }
      }
    }
  }
  .section-hot{
    padding: 82px 0 90px;
    background: url('/images/rexiaodanpinbg.png') no-repeat center/cover;
    .btn-40:hover{
      background: #c19357;
      .color-ff{
        color: #fff;
      }
    }
  }
  .section-hot-case{
    padding: 82px 0 90px;
    background: #fff;
    .case-item{
      width: 454px;
      height: 300px;
      border-radius: 4px;
      overflow: hidden;
      &:hover{
        .main{
          display: none;
        }
        .mask{
          display: flex;
        }
      }
      .main{
        width: 100%;
        height: 100%;
        padding: 20px;
        background: rgba($color: #000000, $alpha: 0.5);
      }
      .mask{
        background: rgba($color: #c19357, $alpha: 0.85);
        width: 100%;
        height: 100%;
        display: none;
      }
    }
    .btn-40.bg-292a2e:hover{
      background: #c19357;
      .color-ff{
        color: #fff;
      }
    }
  }
  .section-case{
    padding: 82px 0 90px;
    background: url('/images/zhutuifanganbg.png') no-repeat center/cover;
    .isHover{
      background: #c19357;
      .color-292a2e{
        color: #fff;
      }
    }
  }
  .section-brand{
    padding: 82px 0 90px;
    background: #fff;
     .brand-item{
      width: 335px;
      height: 220px;
      border-radius: 4px;
      margin-bottom: 20px;
      cursor: pointer;
      overflow: hidden;
    .main{
      width: 100%;
      height: 100%;
      padding: 20px;
      background: rgba($color: #000000, $alpha: 0.5);
    }
    .mask{
      background: rgba($color: #c19357, $alpha: 0.85);
      width: 100%;
      height: 100%;
      display: none;
    }
    &:hover{
      .main{
        display: none;
      }
      .mask{
        display: flex;
      }
    }
  }
    .btn-40.bg-292a2e:hover{
      background: #c19357;
      .color-ff{
        color: #fff;
      }
    }
  }
  .section-classic{
    padding: 82px 0 90px;
    background: url('/images/anlibg.png') no-repeat center/cover;
    .main{
      background: #fff;
      width: 100%;
      border-radius: 4px;
      padding: 30px;
      margin-bottom: 10px;
      .pic{
        width: 610px;
        height: 400px;
        border-radius: 4px;
      }
      .line{
        height: 40px;
        width: 1px;
        background: #e9e9e9;
        margin: 0 28px;
      }
      .line-dashed{
        height: 144px;
        width: 1px;
        border-right: 1px dashed #e9e9e9;
        margin: 0 28px;
      }
      .headImg{
        width: 86px;
        height: 86px;
        overflow: hidden;
        border-radius: 50%;
      }
      .room{
        background: #f9f4ee;
        border-radius: 4px;
        height: 75px;
        margin-top: -4px;
      }
      .text{
        line-height: 18px;
      }
      &:hover{
        .btn-25{
          background: #c19357;
          border: 0;
          color: #fff;
        }
      }
    }
    .list-btn{
      cursor: pointer;
      background: rgba($color: #292a2e, $alpha: 0.15);
      width: 30px;
      height: 30px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      i{
        color:#fff;
        font-size: 10px;
        font-weight: bold;
      }
      &:hover{
        background:  #292a2e;
      }
    }
    .list{
      overflow: hidden;
    }
    .picList{
      transition-duration: 0.5s;
    }
    .case-item{
      width: 124px;
      height: 82px;
      border-radius: 4px;
      flex-shrink: 0;
      overflow: hidden;
      cursor: pointer;
      .title{
        background: rgba($color: #000000, $alpha: 0.5);
        &:hover{
          background: rgba($color: #c19357, $alpha: 0.85);
        }
      }
    }
    .btn-40.bg-292a2e:hover{
      background: #c19357;
      .color-ff{
        color: #fff;
      }
    }
  }
  .w-55{
    width: 55px;
  }
  .w-77{
    width: 77px;
  }
  .w-124{
    width: 124px;
  }
  .w-147{
    width: 147px;
  }
  ::v-deep{
    .el-carousel__button{
      width: 10px;
      height: 10px;
      background-color:rgba($color: #000000, $alpha: 0.4);
      border-radius: 5px;
      opacity: 1;
    }
    .el-carousel__indicator.is-active button{
      background-color: #c19357;
      width: 30px;
    }
    .el-carousel__indicators--horizontal{
      bottom: 140px;
    }
    .el-rate__icon{
      font-size: 14px;
      margin-right: 0px;
    }
  }
</style>
